import React, { Fragment, useContext } from "react";
import __ from "lodash";
import {useQueryClient} from "react-query";
import { Icon, makeStyles } from "@material-ui/core";
import { ActionButton } from "./controls";
import { FoodIcon } from "../../../icons";
import useCateringOrders from "../../../services/flights/useCateringOrders";
import TripToolTipStyles from "../TripToolTipStyles";
import { ComboSelect } from "../..";
import useColour from "../../../services/settings/useColour";
import { useFlights } from "../../../services/flights";
import SystemContext from "../../../SystemContext";

const CateringScreen = (props) => {
  const {tripData, eventBus} = props;

  const SystemData = useContext(SystemContext);
  const classes = makeStyles(TripToolTipStyles)();
  const queryClient = useQueryClient();
  const extraKeys = [tripData.uuid];
  const cateringOrder = useCateringOrders({queryClient, extraKeys});
  const flight = useFlights({queryClient, extraKeys});

  let mealRecords = [];
  let dryStoreRecords = [];
  let record = [];

  if (tripData?.indicators?.catering?.status !== 'NOT REQUIRED' && cateringOrder && Array.isArray(cateringOrder.data) && cateringOrder.data.length > 0) {
    record = cateringOrder.data[0];
    const meals = record.meals;
    const dryStores = record.dryStores;
    if (Array.isArray(meals)) {
      mealRecords = __.filter(meals, (meal) => (meal.quantityRequired > 0 || meal.quantityOrdered > 0));
    }
    if (record.replenishDryStore && Array.isArray(dryStores)) {
      dryStoreRecords = __.filter(dryStores, (item) => (item.quantityRequired > 0 || item.quantityOrdered > 0));
    }
  }
  const status = record.status==='CONFIRMED' && props.indicators?.catering?.status === 'REQUIRED'?'REVIEW':record.status||'REQUIRED';
  const backgroundColor = useColour({code: 'CATERING BACKGROUND', status});
  const color = useColour({code: 'CATERING TEXT', status});

  const CateringRow = (props) => {
    return (
      <div className={classes.cateringRow}>
        <div style={{fontWeight: "700", display: "inline-block", width: "75%"}}>{props.itemName}</div>
        <div style={{display: "inline-block", width: "22%", textAlign: "right"}}>{props.required}</div>
        {/*<div style={{display: "inline-block", width: "12%", textAlign: "right"}}>{props.ordered}</div>*/}
      </div>
    );
  }
  const CateringTableHeader = (props) => {
    return (
      <div className={classes.cateringTableHeader}>
        <div style={{fontWeight: "700", display: "inline-block", width: "75%"}}>Item Name</div>
        <div style={{display: "inline-block", width: "22%", textAlign: "right"}}>Required</div>
        {/*<div style={{display: "inline-block", width: "12%", textAlign: "right"}}>Ordered</div>*/}
      </div>
    );
  }
  if ((props?.indicators?.catering?.status||'NOT REQUIRED') === 'NOT REQUIRED') {
    return (
      <Fragment>
        <div style={{width: "100%", paddingBottom: 5}}>
          <div style={{display: "inline-block"}}><FoodIcon style={{position: "relative", top: 2}}/></div>
          <div style={{display: "inline-block", textAlign: "left", fontSize: 20, fontWeight: "bold", marginLeft: 3}}>Catering Details</div>
        </div>
        <div style={{fontSize: 16, fontWeight: "bold", padding: 10, textAlign: "center", border: "1px solid #ffffff", color: "#000000", backgroundColor: "#dddddd"}}>
          Catering is not required for this flight.
        </div>
      </Fragment>
    )
  }
  return (<Fragment>
    <div style={{width: "100%", paddingBottom: 5}}>
      <div style={{display: "inline-block"}}><FoodIcon style={{position: "relative", top: 2}}/></div>
      <div style={{display: "inline-block", textAlign: "left", fontSize: 20, fontWeight: "bold", marginLeft: 3}}>Catering Details</div>
      <div style={{display: "inline-block", float:"right", textAlign: "right"}}>
        <ActionButton
          variant="outlined"
          startIcon={<Icon>edit</Icon>}
          onClick={()=>{
            if (flight && Array.isArray(flight.data) && flight.data.length > 0)
            if (!flight.data[0].crew || (Array.isArray(flight.data[0].crew) && flight.data[0].crew.length < 1)){
              SystemData.openAlert("Catering Prerequisites", "Crew numbers must be captured in order to generate catering orders", {zIndex: 10002});
            } else {
              eventBus.trigger("RouteView.TimeWindow.TripAction.editCatering",{tripData: flight.data[0], extraKeys});
            }
          }}
        >
          Edit
        </ActionButton>
      </div>
    </div>
    <div className={classes.cateringStatusRow}>
      <div style={{fontWeight: "700", display: "inline-block", width: 70}}>Status:</div>
      <div style={{display: "inline-block", backgroundColor, color, padding:"3px 5px"}}>
        <ComboSelect
          group={record.status==='CONFIRMED' && props.indicators?.catering?.status === 'REQUIRED'?"CATERING ORDER REVIEW STATUS":"CATERING ORDER STATUS"}
          subGroup=""
          value={record.status==='CONFIRMED' && props.indicators?.catering?.status === 'REQUIRED'?'REVIEW':record.status||'REQUIRED'}
          displayOnly={true}
        />
      </div>
      <div style={{float: "right"}}>
        <div style={{fontWeight: "700", display: "inline-block", width: 70}}>Ordered:</div>
        <div style={{display: "inline-block"}}>{record.orderDate}</div>
      </div>
    </div>
    <div style={{width: "100%"}}>
      <div className={classes.cateringHeader}>
        <div style={{display: "inline-block"}}><Icon style={{position: "relative", top: 2, width: 16, height: 16, fontSize: "16px"}}>restaurant</Icon></div>
        <div style={{display: "inline-block", textAlign: "left", fontSize: 16, fontWeight: "bold", marginLeft: 3}}>Meals</div>
      </div>
      {mealRecords && mealRecords.length > 0 ?
        <div>
          <CateringTableHeader/>
          {(mealRecords||[]).map(record => (
            <CateringRow itemName={record.cateringItemName} required={record.quantityRequired} ordered={record.quantityOrdered}/>
          ))}
        </div>
      :
        <div style={{fontSize: 16, fontWeight: "bold", padding: 10, textAlign: "center", border: "1px solid #ffffff", color: "#000000", backgroundColor: "#dddddd"}}>
          No meals booked for this flight
        </div>
      }
    </div>
    <div style={{width: "100%"}}>
      <div className={classes.cateringHeader}>
        <div style={{display: "inline-block"}}><Icon style={{position: "relative", top: 2, width: 16, height: 16, fontSize: "16px"}}>emoji_food_beverage</Icon></div>
        <div style={{display: "inline-block", textAlign: "left", fontSize: 16, fontWeight: "bold", marginLeft: 3}}>Dry Stores</div>
      </div>
      {dryStoreRecords && dryStoreRecords.length > 0 ?
        <div>
          <CateringTableHeader/>
          {(dryStoreRecords||[]).map(record => (
            <CateringRow itemName={record.cateringItemName} required={record.quantityRequired} ordered={record.quantityOrdered}/>
          ))}
        </div>
      :
        <div style={{fontSize: 16, fontWeight: "bold", padding: 10, textAlign: "center", border: "1px solid #ffffff", color: "#000000", backgroundColor: "#dddddd"}}>
          No replenishment of dry stores required
        </div>
      }
    </div>

  </Fragment>);
}

export default CateringScreen;
